import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";
import { Link } from "@reach/router";

function Quarry(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Being a quarry in Liverpool is pretty good now if a bit boring. In
            the old days when horse folk pulled the carts of stone from me they
            would have a chat whilst they were waiting and they would tell me
            all the gossip. Now I have plant, tree and animal folk for friends
            and there are human dwellings in one quarry, they keep me pretty
            nice, but it's so quiet,
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              would you like to know more about my past?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I'm proud to say I supplied the sandstone for Liverpool's Anglican
            Cathedral, but now it's built the humans don't need me anymore and
            instead they get cheap sandstone from India for their patios etc.
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              {" "}
              Why do I think this is wrong?
            </button>{" "}
          </p>
          <p>
            I also have a famous connection in that the original Beatles were
            named the 'Quarrymen' after me
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(6);
              }}
            >
              I have an idea how this could be promoted.
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            The Indian sandstone is allegedly quarried by children! I would much
            rather resume supply even though it would cost the humans more I
            will have to think of a way to{" "}
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              persuade the humans to stop this.
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Perhaps I could get a marketing team together to advertise my
            sandstone as Liverpool Sandstone, what do you think? Do you think
            this is a good idea or a bad idea?
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              Good Idea
            </button>{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              Bad Idea
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Yes I think you're right, the humans might want to have their homes
            built from the same stone at the Anglican Cathedral and I would get
            to see more people again, maybe the horses would come back?
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Oh right, I see what you mean, they wouldn't be using horse and cart
            this time, but those big drilling machines and huge dirty vehicles.
            I don't think I'd like that, it used to tickle when they chipped
            away at me, I don't fancy being pulled apart by those nasty invasive
            drills. I might just hibernate for a few hundred thousand years and
            see what's happening when I wake up.
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 6) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I would like the council to put blue plaques at my entrances, to
            tell the humans how I inspired the Beatles to name themselves after
            me, what do you think? Do you think it is a really good idea or a
            really bad idea?
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(7);
              }}
            >
              Good Idea
            </button>{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(8);
              }}
            >
              Bad Idea
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 7) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I know right? We'd have busloads of humans come along, so if humans
            started to visit me as a tourist attraction then they might start to
            really notice and appreciate us natural features, we can start with
            the Beatles, but when they start to really think about the rocks
            that lie beneath them, they might look at the city a bit
            differently.
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 8) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Yes you're probably right, I mean those magical Mystery Tour buses
            are a total nightmare, I don't want those driving up inside me,
            dropping off little herds of tourists, they're so noisy and tickly.
          </p>
        </div>
      </div>
    );
  }
}

export default Quarry;
